import { useTranslation } from "react-i18next";

import { Dropdown } from "components";
import "components/BrandGroupSelect/BrandGroupSelect.scss";
import { useBrandGroupSelect } from "components/BrandGroupSelect/hooks";
import { searchBrandGroups } from "modules/BrandsDashboard/utils";

import type { BrandGroupID } from "models";
import type { DropdownItemProps } from "semantic-ui-react";

type BrandGroupSelectProps = {
  value: BrandGroupID[];
  onChange: (brandGroupIds: BrandGroupID[]) => void;
  disabled?: boolean;
  showAllBrands?: boolean;
};

export const BrandGroupSelect = ({ value, onChange, disabled, showAllBrands }: BrandGroupSelectProps) => {
  const { t } = useTranslation();

  const { brandsWithGroupsOptions, selectedOptionValues, handleOnSelectionChange } = useBrandGroupSelect({
    selectedBrandGroupIds: value,
    onChange,
    showAllBrands
  });

  return (
    <div className="BrandGroupSelect">
      <Dropdown
        fluid
        clearable
        selection
        multiple
        search={searchBrandGroups}
        name="brand_groups"
        disabled={disabled}
        selectOnBlur={false}
        value={selectedOptionValues}
        options={brandsWithGroupsOptions}
        placeholder={t("v8_select_brand_group", "Select Brand Group")}
        onChange={handleOnSelectionChange}
        renderLabel={(option: DropdownItemProps) => ({ content: option.text, icon: option.icon, className: "brand-group-label" })}
      />
    </div>
  );
};
